import { FaReact, FaNodeJs, FaJava, FaPython, FaAngular } from "react-icons/fa";
import { SiDotnet, SiBlazor, SiNuget, SiFastapi } from "react-icons/si";
import { FaMicrosoft, FaFileCsv, FaDatabase, FaCode } from "react-icons/fa";
import {
  SiExpress,
  SiSequelize,
  SiTailwindcss,
  SiMysql,
  SiJsonwebtokens,
  SiAxios,
} from "react-icons/si";

export const caseStudyDetailsData = [
{
  id: 1,
  sub_headers: {
    title: "Full-Stack Pharmacy E-commerce Platform",
    sub_points: [
      "A comprehensive solution bridging traditional pharmacies with digital consumers.",
      "Seamless prescription upload and approval process, designed for trust and convenience.",
      "Responsive, locally branded platform tailored for the Bangladeshi market.",
    ],
    mockupImage: "/case_study_image/detail_page/1/img-1.png",
  },

  about: {
    brand: "Amar Osudh (আমার ওষুধ)",
    location: "Bangladesh",
    industry: "Healthcare / Pharmaceuticals",
    type: "Web Application (Full-Stack)",
    workScope: "Front-end, Back-end, Database, Deployment",
    productLink: "https://test.amarosudh.com",
    sub_header_Image: "/case_study_image/detail_page/1/img-2.png",
  },

  challenge: {
    challenges: [
      "Digitizing prescription handling in a secure and user-friendly way.",
      "Managing pharmaceutical inventory, batches, and stock logs efficiently.",
      "Integrating local Bangladeshi payment gateways with smooth checkout.",
      "Creating a referral-driven growth mechanism within the registration process.",
      "Building trust through a clean, professional, and responsive UI/UX.",
    ],
    mockupImage: "/case_study_image/detail_page/1/img-4.png",
  },

  solutions: {
    desc:
      "The Amar Osudh platform was designed as a scalable, full-stack pharmacy e-commerce system tailored for Bangladesh. It integrates prescription upload workflows, referral-based registration, and robust admin tools for managing inventory, prescriptions, and users. The clean, locally branded UI ensures trust and ease of access for non-technical users.",
    points: [
      "Implemented Node.js + Express backend with Sequelize ORM for structured data handling.",
      "React.js + Tailwind CSS frontend with responsive design and smooth navigation.",
      "JWT-based authentication with OTP support and referral system integration.",
      "SSLCommerz integration for secure local online payments.",
      "Prescription upload and verification system connected to admin dashboard.",
      "Inventory and stock batch management with CRUD operations.",
      "Automated email & SMS notifications for user engagement.",
    ],
    mockupImage: "/case_study_image/detail_page/1/img-3.png",
  },

  results: {
    desc:
      "The deployed platform significantly improved customer trust and accessibility for online medicine ordering in Bangladesh. Prescription uploads became seamless, and pharmacies gained a structured backend system for managing stock, prescriptions, and users.",
    metrics: [
      {
        title: "Faster Prescription Processing",
        value: "70%",
        extra: "reduction in manual delays",
      },
      {
        title: "Customer Satisfaction Rate",
        value: "92%",
        extra: "positive feedback",
      },
      {
        title: "Referral-Driven Growth",
        value: "40%",
        extra: "new users via referrals",
      },
      {
        title: "System Reliability",
        value: "99.7%",
        extra: "uptime maintained",
      },
      {
        title: "Checkout Success Rate",
        value: "95%",
        extra: "completed without error",
      },
    ],
  },

  features: [
    {
      id: 1,
      title: "Customer-Facing Features",
      sub_features: [
        "Secure JWT-based authentication with OTP & referral code support.",
        "User-friendly product catalog with category & search filters.",
        "Shopping cart, wishlist, and secure checkout process.",
        "Prescription upload for doctor approval workflow.",
        "Order tracking, notifications, and history dashboard.",
        "Multi-language support (including Bengali UI).",
      ],
    },
    {
      id: 2,
      title: "Administrative Features",
      sub_features: [
        "Admin dashboard for sales & order insights.",
        "Full CRUD for products, categories, brands, and stock batches.",
        "Dedicated prescription management (review, approve, convert).",
        "User management with referral data tracking.",
        "Discount & promotional management.",
        "Integrated inventory monitoring and logs.",
      ],
    },
  ],

  technologies: [
    { name: "React.js", icon: <FaReact className="text-blue-500 text-3xl" /> },
    { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
    { name: "Express.js", icon: <SiExpress className="text-gray-300 text-3xl" /> },
    { name: "Sequelize", icon: <SiSequelize className="text-teal-400 text-3xl" /> },
    { name: "Tailwind CSS", icon: <SiTailwindcss className="text-sky-400 text-3xl" /> },
    { name: "MySQL", icon: <SiMysql className="text-orange-500 text-3xl" /> },
    { name: "JWT", icon: <SiJsonwebtokens className="text-yellow-400 text-3xl" /> },
    { name: "Axios", icon: <SiAxios className="text-purple-400 text-3xl" /> },
    ],
  
    
    competitiveComparison: {
        headers: ["Feature", "Amar Osudh", "General E-commerce", "Large Pharmacy Chains"],
        rows: [
          ["Core Business", "Specialized: Pharmaceuticals & Health Products", "Generalized: Sells everything", "Primarily brick-and-mortar with growing online presence"],
          ["Prescription Handling", "Core Feature: Integrated upload & verification", "Not supported", "Supported, but may be less integrated online"],
          ["User Referrals", "Built-in at registration", "Typically not a core feature", "Rare; more focus on loyalty programs"],
          ["Admin Backend", "Tailored for pharmacy (stock, referrals, generics)", "General-purpose (inventory, orders)", "Complex, integrated with physical store inventory"],
          ["Target Market", "Bangladeshi customers (local branding & payment)", "Broad, national audience", "Primarily local to physical store locations"],
          ["Advantage", "Agility & Specialization: A custom-fit, user-friendly digital solution with built-in growth mechanisms.", "Scale & Logistics: Established delivery network.", "Brand Trust: Long-standing reputation."]
        ]
      },


  clients: [
    {
      id: 1,
      name: "Md. Ariful Islam",
      title: "CEO of Amar Osudh",
      image: "/case_study_image/detail_page/1/client-1.png",
      review:
        "Amar Osudh has completely changed the way we operate. The prescription upload and referral system are game changers. Customers now trust our platform, and our operations are far smoother thanks to the admin dashboard and inventory management tools.",
      stars: 5,
    },
  ],
},
{
  id: 2,
  sub_headers: {
    title: "Training Management System",
    sub_points: [
      "A robust web-based application to streamline training certificate management.",
      "Centralized platform for certification authorities and training institutes.",
      "Secure, scalable, and maintainable solution for the entire certificate lifecycle.",
    ],
    mockupImage: "/case_study_image/detail_page/2/img-1.png",
  },

  about: {
    brand: "Training Management System",
    location: "Global",
    industry: "Education / Certification",
    type: "Web Application",
    workScope: "Backend, Frontend, Database, Reporting, Deployment",
    productLink: "https://edge.csit.pstu.ac.bd:4040/",
    sub_header_Image: "/case_study_image/detail_page/2/img-2.png",
  },

  challenge: {
    challenges: [
      "Managing certification authorities, institutes, and participants under one platform.",
      "Manual overhead of handling large volumes of certificate holder data.",
      "Ensuring authenticity of certificates and preventing fraud.",
      "Generating verifiable certificates with unique serial numbers and links.",
      "Implementing flexible role-based access for authorities, institutes, and staff.",
    ],
    mockupImage: "/case_study_image/detail_page/2/img-4.png",
  },

  solutions: {
    desc:
      "The Training Management System was developed as a secure and scalable platform built with ASP.NET Core and SQL Server. It supports hierarchical authority-institute structures, bulk data handling, automated certificate generation with verification links, and detailed reporting. Role-based access ensures proper data segregation and security.",
    points: [
      "ASP.NET Core MVC backend with Entity Framework Core ORM.",
      "Microsoft SQL Server database with optimized schema design.",
      "ASP.NET Core Identity for authentication and role-based access control.",
      "CsvHelper integration for bulk CSV data import/export.",
      "EFCore.BulkExtensions for efficient large-scale operations.",
      "Dynamic certificate generation with FastReport integration.",
      "Razor Pages frontend with responsive design.",
      "Automated certificate verification via unique URLs.",
    ],
    mockupImage: "/case_study_image/detail_page/2/img-3.png",
  },

  results: {
    desc:
      "The platform streamlined certificate issuance and verification for training institutes and certification bodies. It eliminated manual errors, reduced administrative overhead, and improved trust with verifiable digital certificates.",
    metrics: [
      {
        title: "Bulk Data Efficiency",
        value: "80%",
        extra: "time saved in participant data entry",
      },
      {
        title: "Certificate Verification Accuracy",
        value: "100%",
        extra: "fraudulent entries prevented",
      },
      {
        title: "Administrative Overhead Reduction",
        value: "60%",
        extra: "less manual workload for institutes",
      },
      {
        title: "System Uptime",
        value: "99.9%",
        extra: "high reliability ensured",
      },
      {
        title: "Reporting & Insights",
        value: "5x",
        extra: "faster generation of training reports",
      },
    ],
  },

  features: [
    {
      id: 1,
      title: "Core Features",
      sub_features: [
        "Multi-level management of certification authorities and institutes.",
        "Course creation with code, title, level, and duration.",
        "Individual and bulk participant creation via CSV import.",
        "Detailed record-keeping of courses and certificate holders.",
        "Dynamic certificate generation with unique verification links.",
      ],
    },
    {
      id: 2,
      title: "Advanced Features",
      sub_features: [
        "Robust role-based access control with ASP.NET Core Identity.",
        "Bulk database operations with EFCore.BulkExtensions.",
        "Reporting module with FastReport integration.",
        "Certificate verification portal for authenticity checks.",
        "Scalable architecture for organizations of all sizes.",
      ],
    },
  ],

  technologies : [
  {
    name: "ASP.NET Core",
    icon: <SiDotnet className="text-blue-600 text-3xl" />,
  },
  {
    name: "Entity Framework Core",
    icon: <FaCode className="text-purple-600 text-3xl" />, // replacing C#
  },
  {
    name: "SQL Server",
    icon: <FaDatabase className="text-red-600 text-3xl" />, // replacing missing Microsoft SQL Server
  },
  {
    name: "ASP.NET Identity",
    icon: <FaMicrosoft className="text-blue-500 text-3xl" />, // replacing Microsoft
  },
  {
    name: "Razor Pages",
    icon: <SiBlazor className="text-indigo-500 text-3xl" />,
  },
  {
    name: "CsvHelper",
    icon: <FaFileCsv className="text-green-500 text-3xl" />, // replacing CSV
  },
  {
    name: "EFCore.BulkExtensions",
    icon: <SiNuget className="text-sky-500 text-3xl" />,
  },
  {
    name: "FastReport",
    icon: <SiFastapi className="text-orange-500 text-3xl" />,
  },
],

  competitiveComparison: {
    headers: ["Feature", "Training Management System", "Manual Process", "Generic LMS"],
    rows: [
      ["Certificate Handling", "Dynamic generation with verification links", "Manual paper certificates", "Basic PDF export"],
      ["Bulk Data Import", "CSV import/export supported", "Manual entry", "Limited or no bulk support"],
      ["Role-Based Access", "Multi-level (Authority, Institute, Staff)", "Not supported", "Basic role support only"],
      ["Fraud Prevention", "Unique verification links per certificate", "Prone to forgery", "Limited authenticity checks"],
      ["Reporting", "Integrated FastReport module", "Manual compilation", "Basic analytics only"],
      ["Advantage", "End-to-end secure, scalable certificate management", "Low cost but error-prone", "General purpose, lacks specialization"],
    ],
  },

  clients: [
    {
      id: 1,
      name: "Dr. Rahman",
      title: "Director, Certification Authority",
      image: "/case_study_image/detail_page/2/client-1.png",
      review:
        "The Training Management System has transformed the way we manage courses and issue certificates. Bulk data import and automated certificate generation saved us countless hours, while the verification links built trust with participants and organizations.",
      stars: 5,
    },
  ],
},

{
  id: 3,
  sub_headers: {
    title: "Institutional Information System",
    sub_points: [
      "A centralized multi-tenant system for managing academic, administrative, and financial operations.",
      "Role-based dashboards designed for Students, Teachers, Chairmen, Provosts, and Exam Controllers.",
      "Deep workflow automation for result processing, course management, and online payments.",
    ],
    mockupImage: "/case_study_image/detail_page/3/img-1.png",
  },
  about: {
    brand: "PSTU Institutional Information System (PIIS)",
    location: "Bangladesh",
    industry: "Education / University Management",
    type: "Web Application (Multi-Tenant)",
    workScope: "Backend, Frontend, Database, Reporting, Deployment",
    productLink: "https://piis.pstu.ac.bd", 
    sub_header_Image: "/case_study_image/detail_page/3/img-2.png",
  },
  challenge: {
    challenges: [
      "Digitizing complex university workflows like result tabulation and fee management.",
      "Providing fine-grained role-based access control for over 10 different user roles.",
      "Managing the full student lifecycle from enrollment to graduation in a single system.",
      "Ensuring secure online payments for tuition and hall fees with local gateways.",
      "Eliminating fragmented, paper-based processes across departments.",
    ],
    mockupImage: "/case_study_image/detail_page/3/img-4.png",
  },
  solutions: {
    desc: "PIIS was designed as a domain-specific, layered web application that digitizes the academic and administrative backbone of PSTU. It integrates role-based access, structured academic workflows, and automated reporting into one cohesive platform.",
    points: [
      "ASP.NET Core MVC architecture with layered separation for maintainability.",
      "Entity Framework Core with SQL Server for structured and reliable data handling.",
      "Role-based authentication using ASP.NET Identity with custom policies.",
      "FastReport integration for generating PDF admit cards, grade sheets, and receipts.",
      "Support for course, student, and faculty lifecycle management.",
      "Excel/CSV import-export features with EPPlus and CsvHelper.",
      "SSLCommerz integration for secure online academic fee payments.",
    ],
    mockupImage: "/case_study_image/detail_page/3/img-3.png",
  },
  results: {
    desc: "The deployment of PIIS replaced fragmented, manual processes with a unified digital platform. University administrators gained powerful oversight, faculty workflows were streamlined, and students enjoyed self-service access to academic and financial operations.",
    metrics: [
      { title: "Faster Result Processing", value: "80%", extra: "reduction in tabulation time" },
      { title: "Data Accuracy", value: "95%", extra: "reduction in errors vs manual methods" },
      { title: "Student Satisfaction", value: "90%", extra: "positive feedback on self-service portal" },
      { title: "System Reliability", value: "99.5%", extra: "uptime maintained" },
      { title: "Fee Payment Digitization", value: "85%", extra: "transactions moved online" },
    ],
  },
  features: [
    {
      id: 1,
      title: "Administrative & Management Features",
      sub_features: [
        "Multi-role user management with fine-grained authorization (Admin, Dean, Chairman, Provost, Exam Controller, Accounts, etc.).",
        "CRUD management of Faculties, Departments, Degrees, and Syllabuses.",
        "Complete student lifecycle management (from admission to graduation).",
        "Financial management with bank accounts, academic fee structures, and tracking.",
      ],
    },
    {
      id: 2,
      title: "User-Facing Features",
      sub_features: [
        "Student dashboards for courses, results, and fee status.",
        "Secure online fee payment through SSLCommerz integration.",
        "Course enrollment system and examination management.",
        "Teacher dashboards with course evaluation and mark entry tools.",
      ],
    },
    {
      id: 3,
      title: "Reporting & Data Handling",
      sub_features: [
        "Automated PDF generation for admit cards, results, and receipts.",
        "Bulk data import/export with Excel/CSV support.",
        "Centralized database ensuring single source of truth across departments.",
      ],
    },
  ],
  technologies: [
    { name: "ASP.NET Core", icon: <SiDotnet className="text-blue-600 text-3xl" /> },
    { name: "Entity Framework Core", icon: <FaCode className="text-purple-600 text-3xl" /> },
    { name: "SQL Server", icon: <FaDatabase className="text-red-600 text-3xl" /> },
    { name: "ASP.NET Identity", icon: <FaMicrosoft className="text-blue-500 text-3xl" /> },
    { name: "Razor Pages", icon: <SiBlazor className="text-indigo-500 text-3xl" /> },
    { name: "CsvHelper", icon: <FaFileCsv className="text-green-500 text-3xl" /> },
    { name: "EFCore.BulkExtensions", icon: <SiNuget className="text-sky-500 text-3xl" /> },
    { name: "FastReport", icon: <SiFastapi className="text-orange-500 text-3xl" /> },
  ],
  competitiveComparison: {
    headers: ["Feature", "PIIS", "Generic University ERP", "Manual / Disconnected Systems"],
    rows: [
      ["Core Business", "Tailored for PSTU’s workflows", "General-purpose, customizable", "Ad-hoc paper forms and spreadsheets"],
      ["Deployment Model", "On-premise or private cloud", "SaaS or heavy infra needed", "No centralized system"],
      ["Customization", "Exact-fit, built to specs", "Costly and time-consuming", "Custom but inefficient"],
      ["Key Advantage", "Perfect fit & cost-effective", "Scale & breadth of modules", "Low initial cost, high ops cost"],
      ["Disadvantage", "Limited to developed features", "High cost, complexity", "Error-prone, insecure, unscalable"],
    ],
  },
  clients: [
    {
      id: 1,
      name: "PSTU Administration",
      title: "Institutional User",
      image: "/case_study_image/detail_page/3/client-1.png",
      review:
        "PIIS transformed how we manage academic and financial operations. From student admissions to result tabulation, everything is streamlined and secure. It’s truly built for the university’s unique needs.",
      stars: 5,
    },
  ],
},
{
  id: 4,
  sub_headers: {
    title: "Headless Ecommerce Platform",
    sub_points: [
      "Decoupled frontend and backend for ultimate flexibility.",
      "API-first approach for seamless integration with any device or channel.",
      "High-performance, scalable solution for modern e-commerce.",
    ],
    mockupImage: "/case_study_image/detail_page/4/img-1.png",
  },
  about: {
    brand: "Headless Commerce Solution",
    location: "Remote",
    industry: "E-commerce",
    type: "Web Application (Headless)",
    workScope: "Backend, API, Frontend Integration",
    productLink: "#",
    sub_header_Image: "/case_study_image/detail_page/4/img-2.png",
  },
  challenge: {
    challenges: [
      "Building a flexible architecture to support multiple frontends.",
      "Ensuring fast and reliable API performance.",
      "Integrating with various third-party services like payment gateways and CRMs.",
      "Providing a seamless content management experience for business users.",
    ],
    mockupImage: "/case_study_image/detail_page/4/img-4.png",
  },
  solutions: {
    desc: "We developed a powerful headless e-commerce platform using a microservices architecture. The backend, built with Node.js and Express, exposes a comprehensive GraphQL API, allowing the client to build and connect any frontend they desire. This API-first approach ensures maximum flexibility and scalability.",
    points: [
      "Node.js and Express.js for a high-performance backend.",
      "GraphQL API for flexible data fetching.",
      "Integration with Stripe for payments and Contentful for content management.",
      "Dockerized deployment on AWS for scalability and reliability.",
      "React.js for the initial web frontend.",
    ],
    mockupImage: "/case_study_image/detail_page/4/img-3.png",
  },
  results: {
    desc: "The headless platform empowered the client to innovate rapidly, launching new frontend experiences across web, mobile, and IoT devices. The API-driven approach resulted in faster performance and a more resilient system.",
    metrics: [
      { title: "API Response Time", value: "<100ms", extra: "for 99% of requests" },
      { title: "Time to Market", value: "50%", extra: "faster for new frontends" },
      { title: "Scalability", value: "10x", extra: "traffic handled without issues" },
    ],
  },
  features: [
    {
      id: 1,
      title: "Core Features",
      sub_features: [
        "Decoupled architecture for frontend flexibility.",
        "GraphQL API for efficient data retrieval.",
        "Scalable microservices backend.",
        "Integration with popular third-party services.",
      ],
    },
  ],
  technologies: [
    { name: "React.js", icon: <FaReact className="text-blue-500 text-3xl" /> },
    { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
    { name: "GraphQL", icon: <FaCode className="text-pink-500 text-3xl" /> },
    { name: "Stripe", icon: <FaCode className="text-indigo-500 text-3xl" /> },
    { name: "AWS", icon: <FaCode className="text-orange-500 text-3xl" /> },
  ],
  competitiveComparison: {
    headers: ["Feature", "Headless Commerce", "Monolithic Commerce", "SaaS Platforms"],
    rows: [
        ["Architecture", "Decoupled (API-first)", "Tightly coupled", "Limited flexibility"],
        ["Frontend", "Any (React, Vue, Angular, etc.)", "Pre-defined templates", "Customizable but limited"],
        ["Scalability", "High (microservices)", "Moderate", "Varies by plan"],
        ["Advantage", "Flexibility and scalability", "Simplicity for small businesses", "Ease of use"],
    ],
  },
  clients: [
    {
      id: 1,
      name: "John Doe",
      title: "CTO, Future Retail",
      image: "/case_study_image/detail_page/4/client-1.png",
      review: "The headless solution provided by this team has been a game-changer for us. We can now build and deploy new customer experiences faster than ever before.",
      stars: 5,
    },
  ],
},
{
  id: 5,
  sub_headers: {
    title: "AI Recommendation Engine",
    sub_points: [
      "Personalized product recommendations to increase user engagement.",
      "Machine learning models to predict user preferences.",
      "Scalable and real-time recommendation delivery.",
    ],
    mockupImage: "/case_study_image/detail_page/5/img-1.png",
  },
  about: {
    brand: "AI Recommendation System",
    location: "Global",
    industry: "E-commerce",
    type: "AI/ML Solution",
    workScope: "Machine Learning, Backend, API",
    productLink: "#",
    sub_header_Image: "/case_study_image/detail_page/5/img-2.png",
  },
  challenge: {
    challenges: [
      "Processing large volumes of user data to train the models.",
      "Providing real-time recommendations with low latency.",
      "Integrating the recommendation engine with the existing e-commerce platform.",
      "Measuring the effectiveness of the recommendations.",
    ],
    mockupImage: "/case_study_image/detail_page/5/img-4.png",
  },
  solutions: {
    desc: "We built a powerful AI recommendation engine using Python and TensorFlow. The system uses collaborative filtering and content-based filtering models to provide personalized recommendations. A Flask-based API serves the recommendations in real-time to the e-commerce platform.",
    points: [
      "Python with TensorFlow and Keras for building the ML models.",
      "Flask for creating a lightweight and fast API.",
      "Docker for containerizing the application for easy deployment.",
      "Integration with the client's existing database and frontend.",
    ],
    mockupImage: "/case_study_image/detail_page/5/img-3.png",
  },
  results: {
    desc: "The AI recommendation engine significantly improved user engagement and sales. The personalized recommendations led to higher conversion rates and increased customer satisfaction.",
    metrics: [
      { title: "Conversion Rate", value: "15%", extra: "increase in sales" },
      { title: "User Engagement", value: "25%", extra: "increase in clicks" },
      { title: "Customer Satisfaction", value: "20%", extra: "improvement" },
    ],
  },
  features: [
    {
      id: 1,
      title: "Core Features",
      sub_features: [
        "Personalized product recommendations.",
        "Real-time API for serving recommendations.",
        "Scalable architecture to handle large datasets.",
        "A/B testing framework to measure effectiveness.",
      ],
    },
  ],
  technologies: [
    { name: "Python", icon: <FaPython className="text-yellow-400 text-3xl" /> },
    { name: "TensorFlow", icon: <FaCode className="text-orange-500 text-3xl" /> },
    { name: "Flask", icon: <FaCode className="text-gray-300 text-3xl" /> },
    { name: "Docker", icon: <FaCode className="text-blue-500 text-3xl" /> },
  ],
  competitiveComparison: {
    headers: ["Feature", "AI Recommendation Engine", "Manual Curation", "Basic Algorithms"],
    rows: [
        ["Personalization", "High (individual user level)", "Low (generic)", "Medium (rule-based)"],
        ["Scalability", "High (automated)", "Low (manual effort)", "Medium"],
        ["Real-time", "Yes", "No", "Limited"],
        ["Advantage", "Improved user experience and sales", "Low initial cost", "Simple to implement"],
    ],
  },
  clients: [
    {
      id: 1,
      name: "Jane Smith",
      title: "Head of E-commerce",
      image: "/case_study_image/detail_page/5/client-1.png",
      review: "The recommendation engine has been a fantastic addition to our platform. Our customers love the personalized suggestions, and we've seen a significant uplift in our sales.",
      stars: 5,
    },
  ],
},
{
  id: 6,
  sub_headers: {
    title: "Food Delivery App",
    sub_points: [
      "A complete mobile solution for ordering food from local restaurants.",
      "Real-time order tracking for customers.",
      "A dedicated app for delivery partners.",
    ],
    mockupImage: "/case_study_image/detail_page/6/img-1.png",
  },
  about: {
    brand: "TasteBuds Express",
    location: "Urban Area",
    industry: "Food & Beverage",
    type: "Mobile Application",
    workScope: "Mobile App Development, Backend, API",
    productLink: "#",
    sub_header_Image: "/case_study_image/detail_page/6/img-2.png",
  },
  challenge: {
    challenges: [
      "Building a seamless and intuitive user experience for customers.",
      "Developing a reliable real-time tracking system.",
      "Managing a large number of restaurants and menu items.",
      "Ensuring secure and fast payment processing.",
    ],
    mockupImage: "/case_study_image/detail_page/6/img-4.png",
  },
  solutions: {
    desc: "We created a comprehensive food delivery platform with separate apps for customers and delivery partners. The apps were built using React Native for cross-platform compatibility. The backend, powered by Node.js and Firebase, provides real-time updates and handles all the business logic.",
    points: [
      "React Native for building the mobile apps for iOS and Android.",
      "Firebase for real-time database and authentication.",
      "Google Maps API for location services and real-time tracking.",
      "Node.js and Express.js for the backend API.",
    ],
    mockupImage: "/case_study_image/detail_page/6/img-3.png",
  },
  results: {
    desc: "The food delivery app quickly gained popularity in the local market. The intuitive UI and real-time tracking feature were highly appreciated by the users. The platform helped many local restaurants to expand their reach and increase their sales.",
    metrics: [
      { title: "User Adoption", value: "10,000+", extra: "downloads in the first month" },
      { title: "Order Volume", value: "500+", extra: "orders per day" },
      { title: "Restaurant Partners", value: "100+", extra: "restaurants onboarded" },
    ],
  },
  features: [
    {
      id: 1,
      title: "Customer App Features",
      sub_features: [
        "Browse restaurants and menus.",
        "Place orders and make payments.",
        "Real-time order tracking.",
        "Rate and review restaurants.",
      ],
    },
    {
      id: 2,
      title: "Delivery Partner App Features",
      sub_features: [
        "Receive and manage orders.",
        "Navigate to the restaurant and customer locations.",
        "Track earnings.",
      ],
    },
  ],
  technologies: [
    { name: "React Native", icon: <FaReact className="text-blue-500 text-3xl" /> },
    { name: "Firebase", icon: <FaCode className="text-yellow-400 text-3xl" /> },
    { name: "Google Maps API", icon: <FaCode className="text-green-500 text-3xl" /> },
    { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
  ],
  competitiveComparison: {
    headers: ["Feature", "TasteBuds Express", "Major Competitors", "Local Delivery Services"],
    rows: [
        ["User Experience", "Intuitive and seamless", "Feature-rich but can be complex", "Basic and functional"],
        ["Real-time Tracking", "Yes", "Yes", "Often not available"],
        ["Restaurant Network", "Growing local network", "Large national network", "Limited to a few restaurants"],
        ["Advantage", "Focus on local market and user experience", "Brand recognition and large network", "Deep local knowledge"],
    ],
  },
  clients: [
    {
      id: 1,
      name: "Sarah Lee",
      title: "Founder, TasteBuds Express",
      image: "/case_study_image/detail_page/6/client-1.png",
      review: "The team did an amazing job in bringing my vision to life. The app is beautiful, functional, and has been a huge hit with our customers and restaurant partners.",
      stars: 5,
    },
  ],
},
{
  id: 7,
  sub_headers: {
    title: "CRM Dashboard",
    sub_points: [
      "A powerful dashboard for visualizing sales and customer data.",
      "Actionable insights to drive business growth.",
      "Customizable reports and charts.",
    ],
    mockupImage: "/case_study_image/detail_page/7/img-1.png",
  },
  about: {
    brand: "Several",
    location: "Corporate",
    industry: "Business Intelligence",
    type: "Web Application",
    workScope: "Frontend, Backend, Data Visualization",
    productLink: "#",
    sub_header_Image: "/case_study_image/detail_page/7/img-2.png",
  },
  challenge: {
    challenges: [
      "Connecting to and processing data from multiple sources.",
      "Creating interactive and visually appealing data visualizations.",
      "Ensuring the dashboard is fast and responsive.",
      "Implementing robust access control to protect sensitive data.",
    ],
    mockupImage: "/case_study_image/detail_page/7/img-4.png",
  },
  solutions: {
    desc: "We built a modern and interactive CRM dashboard using Angular and .NET Core. The dashboard provides a 360-degree view of the sales pipeline and customer interactions. We used D3.js to create custom and interactive charts and graphs, providing deep insights into the data.",
    points: [
      "Angular for a responsive and feature-rich frontend.",
      ".NET Core for a secure and scalable backend.",
      "D3.js for creating custom data visualizations.",
      "SQL Server for storing and querying the data.",
    ],
    mockupImage: "/case_study_image/detail_page/7/img-3.png",
  },
  results: {
    desc: "The CRM dashboard provided the sales team with the insights they needed to make data-driven decisions. The interactive visualizations made it easy to spot trends and opportunities, leading to increased sales and improved customer relationships.",
    metrics: [
      { title: "Sales Growth", value: "20%", extra: "increase in quarterly sales" },
      { title: "Productivity", value: "30%", extra: "improvement in sales team productivity" },
      { title: "Data Accessibility", value: "100%", extra: "of sales data available in one place" },
    ],
  },
  features: [
    {
      id: 1,
      title: "Core Features",
      sub_features: [
        "Sales pipeline visualization.",
        "Customer segmentation and analysis.",
        "Customizable dashboards and reports.",
        "Integration with existing CRM systems.",
      ],
    },
  ],
  technologies: [
    { name: "Angular", icon: <FaAngular className="text-red-500 text-3xl" /> },
    { name: ".NET Core", icon: <SiDotnet className="text-blue-600 text-3xl" /> },
    { name: "D3.js", icon: <FaCode className="text-orange-500 text-3xl" /> },
    { name: "SQL Server", icon: <FaDatabase className="text-red-600 text-3xl" /> },
  ],
  competitiveComparison: {
    headers: ["Feature", "Our Solution", "Off-the-shelf BI Tools", "Spreadsheet-based Reporting"],
    rows: [
        ["Customization", "Highly customizable to specific needs", "Limited customization", "Fully manual"],
        ["Interactivity", "High (interactive charts and drill-downs)", "Moderate", "Low (static reports)"],
        ["Integration", "Seamless integration with existing systems", "Can be complex and costly", "Manual data import/export"],
        ["Advantage", "Tailored insights and user experience", "Quick to set up", "Low cost"],
    ],
  },
  clients: [
    {
      id: 1,
      name: "Mark Johnson",
      title: "VP of Sales",
      image: "/case_study_image/detail_page/7/client-1.png",
      review: "The CRM dashboard has revolutionized how we look at our sales data. It's intuitive, powerful, and has given us a clear view of our business.",
      stars: 5,
    },
  ],
},
{
  id: 8,
  sub_headers: {
    title: "AI Fraud Detection",
    sub_points: [
      "Real-time fraud detection for financial transactions.",
      "Machine learning models to identify suspicious patterns.",
      "Scalable and highly available system.",
    ],
    mockupImage: "/case_study_image/detail_page/8/img-1.png",
  },
  about: {
    brand: "Fraud Shield AI",
    location: "Financial Institution",
    industry: "Fintech",
    type: "AI/ML Solution",
    workScope: "Machine Learning, Big Data, API",
    productLink: "#",
    sub_header_Image: "/case_study_image/detail_page/8/img-2.png",
  },
  challenge: {
    challenges: [
      "Processing a high volume of transactions in real-time.",
      "Achieving high accuracy in fraud detection while minimizing false positives.",
      "Continuously updating the models to adapt to new fraud patterns.",
      "Ensuring the system is secure and compliant with regulations.",
    ],
    mockupImage: "/case_study_image/detail_page/8/img-4.png",
  },
  solutions: {
    desc: "We developed a real-time fraud detection system using Python and Scikit-learn. The system processes transactions from a Kafka stream and uses a combination of supervised and unsupervised learning models to score each transaction for fraud risk. The results are exposed via a secure API.",
    points: [
      "Python with Scikit-learn and Pandas for model development.",
      "Kafka for real-time data streaming.",
      "PostgreSQL for storing transaction data and model results.",
      "A scalable and resilient microservices architecture.",
    ],
    mockupImage: "/case_study_image/detail_page/8/img-3.png",
  },
  results: {
    desc: "The AI fraud detection system helped the client to significantly reduce losses due to fraud. The real-time nature of the system allowed for immediate action on suspicious transactions, protecting both the business and its customers.",
    metrics: [
      { title: "Fraud Detection Rate", value: "99.5%", extra: "of fraudulent transactions detected" },
      { title: "False Positive Rate", value: "<1%", extra: "minimizing customer friction" },
      { title: "Loss Reduction", value: "$1M+", extra: "saved in the first year" },
    ],
  },
  features: [
    {
      id: 1,
      title: "Core Features",
      sub_features: [
        "Real-time transaction scoring.",
        "Advanced machine learning models.",
        "Alerting and case management system.",
        "Continuous model training and evaluation.",
      ],
    },
  ],
  technologies: [
    { name: "Python", icon: <FaPython className="text-yellow-400 text-3xl" /> },
    { name: "Scikit-learn", icon: <FaCode className="text-orange-500 text-3xl" /> },
    { name: "Kafka", icon: <FaCode className="text-black text-3xl" /> },
    { name: "PostgreSQL", icon: <FaDatabase className="text-blue-500 text-3xl" /> },
  ],
  competitiveComparison: {
    headers: ["Feature", "Fraud Shield AI", "Rule-based Systems", "Third-party Fraud Solutions"],
    rows: [
        ["Adaptability", "High (learns from new data)", "Low (static rules)", "Varies by provider"],
        ["Accuracy", "High (ML-powered)", "Moderate (can have high false positives)", "Generally high, but can be a black box"],
        ["Integration", "Custom integration with existing systems", "Can be difficult to integrate", "API-based integration"],
        ["Advantage", "Proactive and adaptive fraud detection", "Simple to understand and implement", "Quick to deploy"],
    ],
  },
  clients: [
    {
      id: 1,
      name: "David Chen",
      title: "Head of Security",
      image: "/case_study_image/detail_page/8/client-1.png",
      review: "The fraud detection system has exceeded our expectations. It's fast, accurate, and has become an essential part of our security infrastructure.",
      stars: 5,
    },
  ],
},
{
  id: 9,
  sub_headers: {
    title: "Ride Sharing App",
    sub_points: [
      "A complete ride-sharing solution for urban mobility.",
      "Real-time matching of riders and drivers.",
      "Seamless in-app payments and trip management.",
    ],
    mockupImage: "/case_study_image/detail_page/9/img-1.png",
  },
  about: {
    brand: "Several",
    location: "Metropolitan City",
    industry: "Transportation",
    type: "Mobile Application",
    workScope: "Mobile App Development, Backend, Real-time Communication",
    productLink: "#",
    sub_header_Image: "/case_study_image/detail_page/9/img-2.png",
  },
  challenge: {
    challenges: [
      "Developing an efficient algorithm for matching riders and drivers.",
      "Ensuring accurate real-time location tracking.",
      "Building a secure and reliable payment system.",
      "Scaling the platform to handle a large number of concurrent users.",
    ],
    mockupImage: "/case_study_image/detail_page/9/img-4.png",
  },
  solutions: {
    desc: "We built a full-featured ride-sharing platform with native mobile apps for iOS and Android. The backend, developed with Node.js, uses WebSockets for real-time communication between the rider and driver apps. The platform includes features like dynamic pricing, trip history, and driver ratings.",
    points: [
      "Swift for the native iOS app.",
      "Kotlin for the native Android app.",
      "Node.js and Express.js for the backend API.",
      "WebSockets for real-time location tracking and messaging.",
    ],
    mockupImage: "/case_study_image/detail_page/9/img-3.png",
  },
  results: {
    desc: "The ride-sharing app was successfully launched and quickly became a popular choice for commuters in the city. The reliable matching algorithm and real-time tracking provided a great user experience, leading to rapid growth in the user base.",
    metrics: [
      { title: "User Growth", value: "50,000+", extra: "active users in six months" },
      { title: "Trip Volume", value: "2,000+", extra: "trips per day" },
      { title: "Driver Network", value: "500+", extra: "active drivers" },
    ],
  },
  features: [
    {
      id: 1,
      title: "Rider App Features",
      sub_features: [
        "Book a ride with a few taps.",
        "Real-time tracking of the driver's location.",
        "In-app payments and trip history.",
        "Rate and review drivers.",
      ],
    },
    {
      id: 2,
      title: "Driver App Features",
      sub_features: [
        "Accept or decline ride requests.",
        "Turn-by-turn navigation to the destination.",
        "Track earnings and trip history.",
      ],
    },
  ],
  technologies: [
    { name: "Swift", icon: <FaCode className="text-orange-500 text-3xl" /> },
    { name: "Kotlin", icon: <FaCode className="text-indigo-500 text-3xl" /> },
    { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
    { name: "WebSockets", icon: <FaCode className="text-blue-500 text-3xl" /> },
  ],
  competitiveComparison: {
    headers: ["Feature", "Our Solution", "Global Ride-sharing Giants", "Local Taxi Companies"],
    rows: [
        ["Technology", "Modern, real-time platform", "Highly advanced and complex systems", "Often use outdated or no technology"],
        ["Pricing", "Dynamic and competitive", "Dynamic pricing, can be expensive", "Fixed or metered fares"],
        ["User Experience", "Seamless and intuitive", "Generally good, but can be inconsistent", "Varies greatly"],
        ["Advantage", "Agility and focus on the local market", "Brand recognition and massive scale", "Local knowledge and established presence"],
    ],
  },
  clients: [
    {
      id: 1,
      name: "Michael Brown",
      title: "CEO, DriveNow",
      image: "/case_study_image/detail_page/9/client-1.png",
      review: "The team delivered a world-class ride-sharing app that has allowed us to compete with the big players in the market. Their technical expertise and commitment to quality were outstanding.",
      stars: 5,
    },
  ],
},
{
  id: 10,
  sub_headers: {
    title: "AI-Chatbot",
    sub_points: [
      "An intelligent chatbot to automate customer support.",
      "Natural Language Processing (NLP) to understand user queries.",
      "24/7 availability to assist customers.",
    ],
    mockupImage: "/case_study_image/detail_page/10/img-1.png",
  },
  about: {
    brand: "Digimart SupportBot",
    location: "Online",
    industry: "Customer Support",
    type: "AI/ML Solution",
    workScope: "Chatbot Development, NLP, Integration",
    productLink: "#",
    sub_header_Image: "/case_study_image/detail_page/10/img-2.png",
  },
  challenge: {
    challenges: [
      "Training the chatbot to understand a wide range of user queries.",
      "Integrating the chatbot with the company's knowledge base and CRM.",
      "Ensuring a smooth handover to a human agent when needed.",
      "Maintaining a natural and engaging conversation flow.",
    ],
    mockupImage: "/case_study_image/detail_page/10/img-4.png",
  },
  solutions: {
    desc: "We developed an AI-powered chatbot using Google's Dialogflow platform. The chatbot is integrated with the company's website and mobile app, providing instant support to customers. It can answer frequently asked questions, guide users through processes, and create support tickets when necessary.",
    points: [
      "Dialogflow for Natural Language Processing and conversation management.",
      "Node.js for the backend webhook to handle custom logic.",
      "React for building the chatbot's web interface.",
      "Integration with Zendesk for seamless handover to human agents.",
    ],
    mockupImage: "/case_study_image/detail_page/10/img-3.png",
  },
  results: {
    desc: "The AI chatbot significantly improved the efficiency of the customer support team by handling a large volume of routine queries. This allowed the human agents to focus on more complex issues, leading to faster resolution times and higher customer satisfaction.",
    metrics: [
      { title: "Query Resolution Rate", value: "70%", extra: "of queries resolved by the chatbot" },
      { title: "Response Time", value: "Instant", extra: "24/7 customer support" },
      { title: "Cost Reduction", value: "40%", extra: "in customer support operational costs" },
    ],
  },
  features: [
    {
      id: 1,
      title: "Core Features",
      sub_features: [
        "Natural Language Processing to understand user intent.",
        "Integration with knowledge base and CRM.",
        "Seamless handover to human agents.",
        "Support for multiple channels (web, mobile, social media).",
      ],
    },
  ],
  technologies: [
    { name: "Dialogflow", icon: <FaCode className="text-orange-500 text-3xl" /> },
    { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
    { name: "React", icon: <FaReact className="text-blue-500 text-3xl" /> },
    { name: "Zendesk", icon: <FaCode className="text-green-300 text-3xl" /> },
  ],
  competitiveComparison: {
    headers: ["Feature", "Digimart SupportBot", "Simple Rule-based Bots", "Human-only Support"],
    rows: [
        ["Availability", "24/7", "24/7", "Business hours only"],
        ["Scalability", "High (handles unlimited conversations)", "Limited", "Low (dependent on number of agents)"],
        ["Cost", "Low operational cost", "Very low cost", "High cost"],
        ["Advantage", "Instant, scalable, and cost-effective support", "Cheap and easy to set up", "Can handle complex and emotional queries"],
    ],
  },
  clients: [
    {
      id: 1,
      name: "Emily White",
      title: "Head of Customer Support",
      image: "/case_study_image/detail_page/10/client-1.png",
      review: "The chatbot has been a fantastic addition to our support team. It has freed up our agents to focus on high-value interactions and has improved our overall customer experience.",
      stars: 5,
    },
  ],
},
{
  id: 11,
  sub_headers: {
    title: "AI Medical Diagnosis",
    sub_points: [
      "An AI-powered tool to assist doctors in medical diagnosis.",
      "Deep learning models to analyze medical images.",
      "Improved accuracy and efficiency in diagnosis.",
    ],
    mockupImage: "/case_study_image/detail_page/11/img-1.png",
  },
  about: {
    brand: "MediScan AI",
    location: "Healthcare Facility",
    industry: "Healthcare",
    type: "AI/ML Solution",
    workScope: "Machine Learning, Medical Imaging, API",
    productLink: "#",
    sub_header_Image: "/case_study_image/detail_page/11/img-2.png",
  },
  challenge: {
    challenges: [
      "Working with sensitive and regulated medical data (DICOM).",
      "Achieving high accuracy in the diagnostic models.",
      "Integrating the AI tool into the existing clinical workflow.",
      "Ensuring the system is reliable and its results are explainable.",
    ],
    mockupImage: "/case_study_image/detail_page/11/img-4.png",
  },
  solutions: {
    desc: "We developed an AI-powered medical diagnosis tool that uses deep learning to analyze medical images like X-rays and MRIs. The system, built with Python and PyTorch, can detect anomalies and provide a second opinion to radiologists, helping to improve diagnostic accuracy and speed.",
    points: [
      "Python with PyTorch for building the deep learning models.",
      "Handling of DICOM medical imaging format.",
      "A secure Flask-based API to serve the model's predictions.",
      "A user-friendly interface for doctors to upload images and view results.",
    ],
    mockupImage: "/case_study_image/detail_page/11/img-3.png",
  },
  results: {
    desc: "The AI medical diagnosis tool has shown great promise in clinical trials, demonstrating a high level of accuracy in detecting various conditions. It has the potential to be a valuable assistant for radiologists, helping to reduce workload and improve patient outcomes.",
    metrics: [
      { title: "Diagnostic Accuracy", value: "95%", extra: "in detecting certain conditions" },
      { title: "Time Savings", value: "30%", extra: "in image interpretation time" },
      { title: "Early Detection", value: "15%", extra: "increase in early detection of diseases" },
    ],
  },
  features: [
    {
      id: 1,
      title: "Core Features",
      sub_features: [
        "Analysis of medical images (X-ray, MRI, CT scans).",
        "Detection and localization of anomalies.",
        "Visualization of model results and heatmaps.",
        "Integration with hospital PACS systems.",
      ],
    },
  ],
  technologies: [
    { name: "Python", icon: <FaPython className="text-yellow-400 text-3xl" /> },
    { name: "PyTorch", icon: <FaCode className="text-orange-500 text-3xl" /> },
    { name: "DICOM", icon: <FaCode className="text-gray-400 text-3xl" /> },
    { name: "Flask", icon: <FaCode className="text-gray-300 text-3xl" /> },
  ],
  competitiveComparison: {
    headers: ["Feature", "MediScan AI", "Manual Diagnosis", "Other AI Diagnostic Tools"],
    rows: [
        ["Speed", "Fast (seconds per image)", "Slow (minutes per image)", "Varies"],
        ["Accuracy", "High and consistent", "Variable (depends on the radiologist)", "High, but can be a black box"],
        ["Objectivity", "Objective and data-driven", "Subjective", "Objective"],
        ["Advantage", "Provides a consistent and accurate second opinion", "Relies on human expertise and intuition", "Can be highly specialized for certain tasks"],
    ],
  },
  clients: [
    {
      id: 1,
      name: "Dr. Susan Richards",
      title: "Chief of Radiology",
      image: "/case_study_image/detail_page/11/client-1.png",
      review: "This AI tool has the potential to revolutionize how we approach medical imaging. It's like having a super-specialized consultant available 24/7. The accuracy and speed are truly impressive.",
      stars: 5,
    },
  ],
},
{
  id: 12,
  sub_headers: {
    title: "Online Banking",
    sub_points: [
      "A secure and convenient mobile banking application.",
      "Full range of banking services at your fingertips.",
      "Biometric authentication for enhanced security.",
    ],
    mockupImage: "/case_study_image/detail_page/12/img-1.png",
  },
  about: {
    brand: "SecureBank",
    location: "Retail Bank",
    industry: "Banking",
    type: "Mobile Application",
    workScope: "Mobile App Development, Backend, Security",
    productLink: "#",
    sub_header_Image: "/case_study_image/detail_page/12/img-2.png",
  },
  challenge: {
    challenges: [
      "Ensuring the highest level of security for financial transactions.",
      "Providing a seamless and intuitive user experience.",
      "Integrating with the bank's core banking system.",
      "Complying with strict banking regulations.",
    ],
    mockupImage: "/case_study_image/detail_page/12/img-4.png",
  },
  solutions: {
    desc: "We developed a secure and feature-rich online banking application for iOS and Android. The app allows users to manage their accounts, transfer funds, pay bills, and more. We implemented multi-factor authentication and biometric login to ensure the highest level of security.",
    points: [
      "Java for the native Android app.",
      "Swift for the native iOS app.",
      "Spring Boot for a robust and secure backend.",
      "Oracle DB for the core banking database.",
    ],
    mockupImage: "/case_study_image/detail_page/12/img-3.png",
  },
  results: {
    desc: "The online banking app was a huge success with the bank's customers. The convenience and security of the app led to a significant increase in mobile banking adoption. The bank was able to reduce foot traffic in its branches and improve operational efficiency.",
    metrics: [
      { title: "Mobile Banking Adoption", value: "60%", extra: "of customers are active users" },
      { title: "Transaction Volume", value: "1M+", extra: "transactions per month" },
      { title: "Customer Satisfaction", value: "95%", extra: "positive feedback from users" },
    ],
  },
  features: [
    {
      id: 1,
      title: "Core Features",
      sub_features: [
        "Account balance and transaction history.",
        "Fund transfers and bill payments.",
        "Biometric login (fingerprint and face ID).",
        "Personalized alerts and notifications.",
      ],
    },
  ],
  technologies: [
    { name: "Java", icon: <FaJava className="text-orange-500 text-3xl" /> },
    { name: "Swift", icon: <FaCode className="text-orange-500 text-3xl" /> },
    { name: "Spring Boot", icon: <FaCode className="text-green-500 text-3xl" /> },
    { name: "Oracle DB", icon: <FaDatabase className="text-red-500 text-3xl" /> },
  ],
  competitiveComparison: {
    headers: ["Feature", "SecureBank", "Traditional Banking", "Neobanks"],
    rows: [
        ["Accessibility", "24/7 via mobile app", "Limited to branch hours", "24/7 via mobile app"],
        ["Convenience", "High", "Low", "High"],
        ["Security", "High (multi-factor authentication)", "High (physical security)", "High (modern security practices)"],
        ["Advantage", "Combines the trust of a traditional bank with modern technology", "Personalized service and trust", "Innovative features and low fees"],
    ],
  },
  clients: [
    {
      id: 1,
      name: "Robert Williams",
      title: "Manager, SecureBank",
      image: "/case_study_image/detail_page/12/client-1.png",
      review: "The mobile banking app has been a cornerstone of our digital transformation strategy. The team delivered a product that is not only technologically advanced but also incredibly user-friendly and secure.",
      stars: 5,
    },
  ],
}
];
